/**
 * Auxiliary Navigation.
 * @format
 */

import React, { useContext } from 'react';
import { NavigationContext } from '@context/navigation-context';
import {
  NavigationData,
  CompanyInfoMenuVocab,
} from '@context/navigation-context-modals';
import { safeUrl } from '@services/drupal-services';
import LanguageSelectorButton from '@components/language-selector/lanugage-selector-button';

interface AuxNavigationProps {
  location: string;
}

/**
 * Auxiliary Navigation.
 */
const AuxiliaryNavigation = (props: AuxNavigationProps): JSX.Element | null => {
  const { location }: AuxNavigationProps = props;
  const navigationData: NavigationData = useContext(NavigationContext);
  const { hdr_top_menu_vocab: auxLinks }: CompanyInfoMenuVocab = navigationData;

  /**
   * Render.
   */
  if (auxLinks) {
    return (
      <nav className={location}>
        <ul>
          {auxLinks.map((auxilaryLink: CompanyInfoMenuVocab, index: number) => {
            const { name, link, new_window: external } = auxilaryLink;
            return (
              <li key={index}>
                <a
                  target={external ? '_blank' : '_self'}
                  rel={external ? 'noreferrer noopener' : ''}
                  href={safeUrl(link)}>
                  {name}
                </a>
              </li>
            );
          })}
          {window.Drupal !== 'undefined' &&
            location !== 'responsive-aux-navigation' && (
              <li className="language-selector-aux-link">
                <LanguageSelectorButton />
              </li>
            )}
        </ul>
      </nav>
    );
  }
  return null;
};
export default AuxiliaryNavigation;
